import { component, prop } from '../../../../decorators';

import flow from 'lodash/flow';

@component
export default class TranscriptItem {
   @prop({ type: Object, required: true }) item
   @prop({ type: String, required: true }) search
   @prop({ type: Number, required: true }) idx

   get from() {
      return this.item.from;
   }

   get to() {
      return this.item.to;
   }

   get duration() {
      return this.to - this.from;
   }

   get html() {
      const { html } = this.replacedData;
      return html.replace(/\n/g, ' <br/>');
   }

   get replacedData() {
      if ( this.search ) {
         const counter = _createCounter();
         const reqexp = new RegExp(this.search, 'ig');
         const html = this.item.text.replace(reqexp, flow(markMe, counter));
         return { count: counter.count, html };
      }
      return { count: 0, html: this.item.text };
   }

   get countOfMatches() {
      return this.replacedData.count;
   }
}


function _createCounter() {
   function identity(d) {
      ++identity.count;
      return d;
   }

   identity.count = 0;

   return identity;
}


function markMe(txt) {
   return `<mark>${txt}</mark>`;
}

